import React from "react";

const BoostSection = () => {
  return (
    <>
      <section id="boostSection">
        <h1 id="boostHead">Boost your links today</h1>
        <button id="boostButton">Get Started</button>
      </section>
    </>
  );
};

export default BoostSection;
